module.exports = __webpack_public_path__ + "static/img/undraw_drone_delivery_5vrm.77bcf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_drone_delivery_5vrm.png
// module id = OHhI
// module chunks = 3